<template>
  <div>
    <b-row>
      <b-col xl="5">
        <form @submit.prevent class="w-100">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="'InventorySearchCustom"
              class="input-serach"
              placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
              v-model="filterInventoryList.search"
              v-on:keyup.13="handlePushMessage"
            ></b-form-input>
            <b-input-group-prepend id="btnInventorySearchCustom">
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </form>
      </b-col>
      <b-col xl="7" class="text-right">
        <div class="d-flex justify-content-xl-end h-100 w-100">
          <b-dropdown
            id="dropdownInventoryCustom"
            text="ตัวเลือกเพิ่มเติม"
            class="ml-2 dropdown-option"
          >
            <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
            <b-dropdown-item>ดาวน์โหลดไฟล์ต้นฉบับ</b-dropdown-item>
          </b-dropdown>
          <InventoryFilter
            name="Custom"
            v-on:onSubmitFilter="onSubmitFilter"
            ref="inventoryFilter"
          />
          <b-button
            id="btnInventoryCustomAddProduct"
            @click="showModal"
            class="btn-main ml-2"
          >
            <span>เพิ่มสินค้า </span>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <InventoryAddProductModal
      ref="addProductModal"
      @add-product="addProduct"
      :listId="listAllDataId"
      name="Custom"
    />
    <div class="mt-3">
      <div class="header-purple">
        <p class="mb-0">
          <strong>การกระจายสินค้ารายชิ้น</strong>
        </p>
      </div>
      <b-table
        responsive
        striped
        class="text-center table-list mb-0"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
        :per-page="filterInventoryList.pageSize"
        :current-page="filterInventoryList.page"
      >
        <template v-slot:cell(imageUrl)="data">
          <div class="position-relative">
            <div
              class="square-box b-contain"
              v-bind:style="{
                'background-image': 'url(' + data.item.imageUrl + ')',
              }"
            ></div>
          </div>
        </template>
        <template v-slot:cell(productName)="data">
          <div class="d-flex align-items-center">
            <div class="text-left">
              <p class="mb-0" v-if="data.item.productSKU">
                <strong>{{ data.item.productSKU }}</strong>
              </p>
              <p class="mb-0" v-else>
                <strong>{{ data.item.sku }}</strong>
              </p>
              <p class="mb-1 text-black-50">{{ data.item.productName }}</p>
              <b-form-checkbox
                :id="'checkboxIsOnLowStock' + data.item.productId"
                v-model="data.item.isOnLowStock"
                :value="1"
                :unchecked-value="0"
                >เข้าเงื่อนไขการกระจายปกติเมื่อจำนวนสินค้าในคลังปกติ</b-form-checkbox
              >
            </div>
          </div>
        </template>
        <template v-slot:cell(totalStock)="data">
          <p class="mb-0">{{ data.item.totalStock | numeral("0,0") }}</p>
          <b-badge
            v-if="data.item.stockstatusId == 0"
            pill
            variant="danger"
            class="px-3 py-2 mt-1"
            >หมด</b-badge
          >
          <b-badge
            v-if="data.item.stockstatusId == 2"
            pill
            variant="warning"
            class="text-white px-3 py-2 mt-1"
            >เหลือน้อย</b-badge
          >
        </template>
        <template v-slot:cell(totalPercent)="data">
          <span
            :id="'totalPercentStockCustom' + data.item.productId"
            :class="{ 'text-danger': sumPercent(data.index) > 100 }"
          >
            {{ sumPercent(data.index) }}%
          </span>
        </template>
        <template
          v-for="field in fields.slice(4)"
          v-slot:[`cell(${field.key})`]="data"
        >
          <div class="error-container" :key="field.key">
            <InputTextStock
              :id="
                'inputPercentStock' + field.key + 'ProdId' + data.item.productId
              "
              textFloat=""
              placeholder=""
              type="number"
              :name="field.key"
              isRequired
              :readonly="checkBranch(data.index, field.key)"
              v-model="data.item[field.key]"
              :isValidate="$v.items.$each.$iter[data.index][field.key].$error"
              :v="$v.items.$each.$iter[data.index][field.key]"
              v-on:onDataChange="onChangePercent(data.item.productId)"
            />

            <div
              class="error-custom"
              v-if="
                !$v.items.$each.$iter[data.index][field.key].$error &&
                  !checkBranch(data.index, field.key)
              "
            >
              <span
                :id="
                  'percentStock' + field.key + 'ProdId' + data.item.productId
                "
                >{{
                  Math.floor(
                    (data.item.totalStock * data.item[field.key]) / 100
                  ) | numeral("0,0")
                }}</span
              >
            </div>
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <font-awesome-icon
            :id="'btnDeleteInventoryCustom' + data.item.productId"
            class="pointer"
            icon="trash-alt"
            @click="
              showModalDelete(
                data.item.productId,
                data.item.SpecialDistributeId
              )
            "
          />
        </template>
      </b-table>

      <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filterInventoryList.page"
              :total-rows="rows"
              :per-page="filterInventoryList.pageSize"
              class="m-md-0 page-item"
              @change="pagination"
            ></b-pagination>
          </div>
          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filterInventoryList.pageSize"
            @change="handleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>

      <div class="mt-4 d-flex justify-content-between">
        <b-button class="btn-main-2" id="cancleInventoryCustom">
          ยกเลิก
        </b-button>
        <b-button @click="checkForm" class="btn-main" id="saveInventoryCustom">
          บันทึก
        </b-button>
      </div>
    </div>

    <ModalAlertConfirm
      msg="ยืนยันการลบ"
      text="คุณแน่ใจหรือไม่ว่าต้องการลบ"
      btnConfirm="ลบ"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirmCustom"
      @confirm="confirmDelete"
    />

    <ModalLoading ref="modalLoadingSave" :hasClose="false" />
    <ModalAlert ref="modalSaveSuccess" text="บันทึกสำเร็จ" />
    <ModalAlertError ref="modalSaveAlert" :text="textAlert" />
  </div>
</template>

<script>
import InventoryFilter from "../inventory-filter/InventoryFilter.vue";
import { required, between, numeric } from "vuelidate/lib/validators";
import InventoryAddProductModal from "./modal/InventoryAddProductModal.vue";
import InputTextStock from "../input/InputTextStock.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";

export default {
  components: {
    InventoryFilter,
    InventoryAddProductModal,
    InputTextStock,
    ModalAlertConfirm,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data() {
    return {
      isWarningSave: false,
      listAllDataId: [],
      called: false,
      isBusy: false,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      rows: 0,
      filterInventoryList: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        page: 1,
        pageSize: 10,
        collections: "",
      },
      branch: [],
      fields: [
        {
          key: "imageUrl",
          label: "ภาพสินค้า",
          class: "w-100px",
        },
        {
          key: "productName",
          label: "SKU - ชื่อสินค้า",
          class: "w-400px",
        },
        {
          key: "totalStock",
          label: "จำนวนทั้งหมด",
          class: "w-100px",
        },
        {
          key: "totalPercent",
          label: "%รวม",
          class: "w-100px",
        },
      ],
      items: [],
      itemsUpdate: [],
      form: {},
      idDelete: 0,
      specialIdDelete: 0,
      listIdDelete: [],
      listSpecialIdDelete: [],
      filterAddStock: {
        SpecialDistributeId: 0,
        ProductId: 0,
        isOnLowStock: 0,
        Branch: [],
      },
      textAlert: "",
    };
  },
  validations() {
    const rules = { items: { $each: {} } };
    this.fields.forEach((item, index) => {
      if (
        item.key !== "imageUrl" &&
        item.key !== "isOnLowStock" &&
        item.key !== "productId" &&
        item.key !== "productName" &&
        item.key !== "productSKU" &&
        item.key !== "sku" &&
        item.key !== "stockStatus" &&
        item.key !== "totalStock" &&
        item.key !== "id" &&
        item.key !== "totalPercent"
      ) {
        rules.items.$each[`${item.key}`] = {
          required: required,
          between: between(0, 100),
          numeric: numeric,
        };
      } else {
        rules.items.$each[`${item.key}`] = {};
      }
    });
    return rules;
  },
  async created() {
    await this.getFilter();
    await this.$refs.inventoryFilter.setFilter({ ...this.filterInventoryList });
    await this.getInventoryList();
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filterInventoryList.search = this.$route.query.search;
      }
      if (this.$route.query.productInventoryTypes) {
        this.filterInventoryList.productInventoryTypes = this.$route.query.productInventoryTypes
          .split(",")
          .map(Number);
      }
      if (this.$route.query.productStatus) {
        this.filterInventoryList.productStatus = this.$route.query.productStatus
          .split(",")
          .map(Number);
      }
      if (this.$route.query.categories) {
        this.filterInventoryList.categories = this.$route.query.categories
          .split(",")
          .map(Number);
      }
      if (this.$route.query.stockStatus) {
        this.filterInventoryList.stockStatus = this.$route.query.stockStatus
          .split(",")
          .map(Number);
      }
      if (this.$route.query.StartDate) {
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if (this.$route.query.EndDate) {
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
      if (this.$route.query.page) {
        this.filterInventoryList.page = parseInt(this.$route.query.page) || 1;
      }
      if (this.$route.query.pageSize) {
        this.filterInventoryList.pageSize =
          parseInt(this.$route.query.pageSize) || 10;
      }
    },
    setFilter(filter) {
      let filterInventoryList = this.filterInventoryList;
      if (filter) filterInventoryList = filter;
      this.$router
        .push({
          path: "/inventory",
          query: {
            brandID: this.$route.query.brandID,
            search: filterInventoryList.search,
            productInventoryTypes: filterInventoryList.productInventoryTypes.toString(),
            productStatus: filterInventoryList.productStatus.toString(),
            categories: filterInventoryList.categories.toString(),
            stockStatus: filterInventoryList.stockStatus.toString(),
            StartDate: filterInventoryList.StartDate || "",
            EndDate: filterInventoryList.EndDate || "",
            pageSize: filterInventoryList.pageSize,
            page: filterInventoryList.page,
            tab: this.$route.query.tab || 1,
          },
        })
        .catch((err) => {});
    },
    isActive: function(menuItem) {
      return this.activeItem == menuItem;
    },
    onSubmitFilter(filter) {
      this.items = [];
      this.listAllDataId = [];
      this.setFilter(filter);
      this.getInventoryList(filter);
    },
    handleChangePerpage(value) {
      if (this.isWarningSave) {
        // alert("กรุณาทำการบันทึกข้อมูลก่อน");
      } else {
        this.filterInventoryList.page = 1;
        this.filterInventoryList.pageSize = value;
        this.setFilter();
        this.getInventoryList();
      }
    },
    pagination(Page) {
      if (this.isWarningSave) {
        // alert("กรุณาทำการบันทึกข้อมูลก่อน");
      } else {
        this.filterInventoryList.page = Page;
        this.setFilter();
        this.getInventoryList();
      }
    },
    async getInventoryList(filter) {
      if (filter) {
        this.filterInventoryList = filter;
      }
      this.isBusy = true;
      await this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/special/list`,
          this.filterInventoryList
        )
        .then((data) => {
          this.rows = data.totalCount;
          this.listAllDataId = data.listAllDataId;
          this.branch = data.data.branch;
          this.items = [];
          for (const i in data.data.product) {
            var newItem = {
              imageUrl: data.data.product[i]["imageUrl"],
              isOnLowStock: data.data.product[i]["isOnLowStock"],
              productId: data.data.product[i]["productId"],
              productSKU: data.data.product[i]["sku"],
              productName: data.data.product[i]["productName"],
              totalStock: data.data.product[i]["totalStock"],
              stockStatus: data.data.product[i]["stockStatus"],
              SpecialDistributeId: data.data.product[i]["specialDistributeId"],
              branch: data.data.product[i]["branch"],
            };
            for (const j in data.data.product[i]["branch"]) {
              newItem[data.data.product[i]["branch"][j].branchId] =
                data.data.product[i]["branch"][j].distributePercent;
            }
            this.items.push(newItem);
          }
        });
      this.addFields();
      this.isBusy = false;
    },
    addFields() {
      if (!this.called) {
        for (const i in this.branch) {
          this.fields.push({
            key: this.branch[i].branchId.toString(),
            label: this.branch[i].branchName,
            class: "w-100px text-nonwrap",
          });
        }
        this.fields.push({
          key: "id",
          label: "",
          class: "w-100px",
        });
        this.called = true;
      }
    },
    onCalCulatedPercent(data, event) {
      // const name = event.target.name;
      const index = data.index;
      if (event.target.value) {
        this.items[index].totalPercent =
          this.items[index].stockLazada +
          this.items[index].stockShopee +
          this.items[index].stockJDCentral +
          this.items[index].stockYoupik +
          this.items[index].stockDDots;
        this.$refs.table.refresh();
      } else {
        this.items[index].totalPercent = this.items[index].totalPercent;
        this.$refs.table.refresh();
      }
    },
    async showModal() {
      await this.$refs["addProductModal"].openModal();
      this.$refs["addProductModal"].unCheckProduct(this.listIdDelete); //เอาที่ลบแล้วติ๊กออก
    },
    addProduct(products, productsId) {
      this.isWarningSave = true;
      this.items = this.items.filter((item) =>
        productsId.includes(item.productId)
      );

      for (let i = 0; i < products.length; i++) {
        if (!this.listAllDataId.includes(products[i].productId)) {
          let total = {
            totalStock: products[i].onlineStock,
            SpecialDistributeId: 0,
          };

          products[i]["branch"] = [];

          for (let j = 0; j < this.branch.length; j++) {
            products[i]["branch"].push({
              branchId: this.branch[j].branchId,
              branchName: this.branch[j].branchName,
              distributePercent: 0,
            });
            products[i][this.branch[j].branchId] = 0;
          }
          this.items.push({ ...products[i], ...total });
        }
      }
      this.rows = this.items.length;
      this.listAllDataId = productsId;

      // ถ้าเคยลบแล้วเพิ่มเข้ามา เอาออกจาก array product id delete
      for (let x in productsId) {
        if (this.listIdDelete.includes(productsId[x])) {
          let index = this.listIdDelete.indexOf(productsId[x]);
          this.listIdDelete.splice(index, 1);
        }
      }
    },
    showModalDelete(productId, specialId) {
      this.$refs.isModalAlertConfirmCustom.show();
      if (productId) {
        this.idDelete = productId;
      } else {
        this.idDelete = 0;
      }

      if (specialId) {
        this.specialIdDelete = specialId;
      } else {
        this.specialIdDelete = 0;
      }
    },
    confirmDelete() {
      this.$refs.isModalAlertConfirmCustom.hide();

      this.$refs.modalLoadingSave.show();
      if (this.idDelete) {
        this.listIdDelete.push(this.idDelete);
        this.items = this.items.filter(
          (item) => !this.listIdDelete.includes(item.productId) // เอาออกจาก item ในตาราง
        );
        // เอาติ๊กออกใน Modal เพิ่มสินค้า
        this.$refs["addProductModal"].unCheckProduct(this.listIdDelete);
      }

      if (
        this.specialIdDelete &&
        !this.listSpecialIdDelete.includes(this.specialIdDelete)
      ) {
        this.listSpecialIdDelete.push(this.specialIdDelete); // เก็บไว้ส่งให้ API
      }

      if (this.specialIdDelete != 0) {
        this.deleteItem();
      }

      this.$refs.modalLoadingSave.hide();
    },
    async deleteItem() {
      await this.axios
        .delete(`${this.$baseUrl}/stockdistribute/special`, {
          data: {
            SpecialDistributeId: this.specialIdDelete,
          },
        })
        .then((data) => {
          this.$refs.modalLoadingSave.hide();
          if (data.result == 0) {
            this.textAlert = data.message;
            this.$refs.modalSaveAlert.show();
          } else {
            this.$refs.modalSaveSuccess.show();
            // this.getInventoryList();
          }
        });
    },
    async checkForm() {
      this.$v.items.$touch();
      if (this.$v.items.$error) {
        return;
      } else {
        this.$refs.modalLoadingSave.show();
        let listItemsUpdate = [];
        for (let i = 0; i < this.items.length; i++) {
          this.filterAddStock = {};
          // if (this.itemsUpdate.includes(this.items[i].productId)) {
          //   this.filterAddStock.SpecialDistributeId = null;
          // } else {}

          // specialDistributedId
          if (this.items[i].SpecialDistributeId) {
            this.filterAddStock.SpecialDistributeId = this.items[
              i
            ].SpecialDistributeId;
          } else {
            this.filterAddStock.SpecialDistributeId = 0;
          }
          // isOnLowStock
          if (this.items[i].isOnLowStock) {
            this.filterAddStock.isOnLowStock = this.items[i].isOnLowStock;
          } else {
            this.filterAddStock.isOnLowStock = 0;
          }
          if (this.items[i].branch) {
            for (let j = 0; j < this.branch.length; j++) {
              // update branch stock
              this.items[i].branch[j].distributePercent = this.items[i][
                this.branch[j]["branchId"]
              ];
            }
            this.filterAddStock.Branch = this.items[i].branch;
          } else {
            this.filterAddStock.Branch = [];
          }
          this.filterAddStock.ProductId = this.items[i].productId;
          listItemsUpdate.push(this.filterAddStock);
        }
        await this.axios
          .post(`${this.$baseUrl}/stockdistribute/special/save`, {
            listSpecialProduct: listItemsUpdate,
            listDelete: this.listSpecialIdDelete,
          })
          .then((data) => {
            this.$refs.modalLoadingSave.hide();
            if (data.result == 0) {
              this.textAlert = data.message;
              this.$refs.modalSaveAlert.show();
            } else {
              this.$refs.modalSaveSuccess.show();
              this.rows = this.listItemsUpdate.length;
              this.getInventoryList();
            }
          });
      }
    },
    checkBranch(index, branchId) {
      for (const key in this.items[index]) {
        if (key === branchId) {
          return false;
        }
      }
      return true;
    },
    sumPercent(row) {
      let total = 0;
      this.items[row].totalPercent = 0;

      for (const key in this.items[row]) {
        if (
          key !== "imageUrl" &&
          key !== "isOnLowStock" &&
          key !== "productId" &&
          key !== "productName" &&
          key !== "productSKU" &&
          key !== "stockStatus" &&
          key !== "totalStock" &&
          key !== "SpecialDistributeId" &&
          key !== "sku" &&
          key !== "onlineStock" &&
          key !== "offlineStock" &&
          this.items[row][key] !== "" &&
          this.items[row][key] > 0
        ) {
          total += parseInt(this.items[row][key]);
        }
      }
      return total;
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
    onChangePercent(productId) {
      if (!this.itemsUpdate.includes(productId)) {
        this.itemsUpdate.push(productId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-inventory {
  border: 1px solid #bcbcbc;
  padding: 8px;
  border-radius: 8px;
}
.list-item {
  padding: 8px;
  display: flex;
  align-items: center;
}

.list-item:not(:last-child) {
  border-bottom: 1px solid #bcbcbc;
}

.img-container {
  width: 80px;
  height: 80px;
}

.error-container {
  position: relative;
}

.error-custom {
  position: absolute;
  left: 0;
  right: 0;
  font-size: 12px;
}
</style>
